import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const SpaExtrasWrapper = styled.div`
  width: 100%;
  padding: 30px 0;
  display: grid;
  justify-content: center;
  ${media.md`
    padding: 30px 20px;
  `}
`;
